import { LANGUAGE } from '@common/constants/global.constants'
import { Language } from '@common/enums/global.enums'
import { GREY_COLORS, WHITE } from '@config/theme/colors'
import { ArrowDropDownRounded } from '@mui/icons-material'
import { MenuItem, Select as MuiSelect, styled, Typography } from '@mui/material'
import { useLanguage } from '@services/contexts/LanguageContext'
import { FormattedMessage } from 'react-intl'

/**
 * Language select input
 * @constructor
 */
const LanguageSelectInput = () => {
	const { locale, switchLanguage } = useLanguage()

	return (
		<Select
			onChange={(event) => switchLanguage(event.target.value as Language)}
			IconComponent={ArrowDropDownRounded}
			value={locale}
		>
			{Object.keys(LANGUAGE).map((language: string) => (
				<MenuItem key={language} value={language}>
					<Typography>
						<FormattedMessage id={`global.lang.${language}`} />
					</Typography>
				</MenuItem>
			))}
		</Select>
	)
}

const Select = styled(MuiSelect)({
	backgroundColor: WHITE,
	borderRadius: '8px',
	boxShadow: '0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A',
	height: '100%',
	'& .MuiSelect-select': {
		display: 'flex',
		alignItems: 'center',
		padding: '0 0 0 12px'
	},
	'& .MuiSelect-icon': {
		color: GREY_COLORS[500]
	},
	'& .MuiOutlinedInput-notchedOutline': {
		border: 'none'
	}
})

export default LanguageSelectInput
